import $ from "jquery";
import { checkNested, getConfig, createGuid, extendArticle } from "./general_functions";
import language from "./translation";

export const warningHtml = (info, where) => {
    return `
                <div class="container p-md-0 alert_main__container ${where}" data-warningid="${info.guid}">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="alert alert-dismissible alert__main alert__main-${info.cssClass}" role="alert">
                                <button type="button" class="close alert__main__close" data-dismiss="${info.guid}" data-contentid="${info.contentId}" aria-label="Close">
                                    <span class="budlight-cross-ui">&nbsp;</span>
                                </button>
                                <div class="row">
                                    <div class="col-12 col-sm-1 pr-sm-0 alert__main__iconplacement">${info.icon}
                                    </div>
                                    <div class="col-12 pl-sm-0 pr-sm-5 col-sm-11">
                                        <h2 class="alert__main__title">${info.title}</h2>
                                        <div class="alert__main__text">${info.content}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              `;
}

export const setWarning = (warnings) => {
    let messages = [];
    if (warnings.totalCount > 0 && warnings.listOfContent.length > 0) {
        warnings.listOfContent.forEach(item => {
            const extendItem = extendArticle(item);
            let type = "Drift";
            let placement = "Hele portalen";
            let warnPages = [];
            let title = extendItem.title;
            let content = decodeURIComponent(extendItem.contentObject);
            let intro = extendItem.intro;
            let articleId = window.contentID;
            let guid = createGuid();

            let types = {
                "Drift": {
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" class="alert__main__icon ic-info">
                                <circle fill="#ffffff" cx="27" cy="27" r="27"/>
                                <path fill="#1e1e1e" d="M 27 18.9 c 0.9 0 1.6 -0.3 2.2 -0.8 c 0.5 -0.5 0.8 -1.2 0.8 -2.1 c 0 -0.9 -0.3 -1.6 -0.8 -2.1 C 28.6 13.3 27.9 13 27 13 c -0.9 0 -1.6 0.3 -2.2 0.8 c -0.6 0.5 -0.8 1.3 -0.8 2.1 c 0 0.9 0.3 1.6 0.8 2.1 c 0.6 0.5 1.3 0.8 2.2 0.8 z m 1.9 21.6 c 0.4 0 0.6 -0.2 0.6 -0.6 V 23.2 c 0 -0.4 -0.2 -0.6 -0.6 -0.6 H 25.1 c -0.4 0 -0.6 0.2 -0.6 0.6 v 16.7 c 0 0.4 0.2 0.6 0.6 0.6 h 3.7 z" transform="translate(-172,-472) translate(150,440) translate(0,10) translate(22,22)"/>
                            </svg>`,
                    cssClass: "info"
                },
                "Mindre viktig": {
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54"  class="alert__main__icon ic-warn">
                                <circle fill="#1e1e1e" cx="27" cy="27" r="27" />
                                <path fill="#ffffff" d="M 28.6 32.6 c 0.5 0 0.8 -0.2 0.8 -0.7 l 0.6 -18.2 c 0 -0.5 -0.2 -0.7 -0.7 -0.7 h -4.6 c -0.5 0 -0.7 0.2 -0.7 0.7 l 0.5 18.2 c 0 0.5 0.2 0.7 0.7 0.7 h 3.4 z M 26.9 42.8 c 1.1 0 2 -0.4 2.8 -1.1 c 0.8 -0.7 1.1 -1.6 1.1 -2.6 c 0 -1 -0.4 -1.9 -1.2 -2.6 c -0.8 -0.7 -1.7 -1.1 -2.7 -1.1 s -1.9 0.4 -2.7 1.1 c -0.8 0.7 -1.2 1.6 -1.2 2.6 c 0 1 0.4 1.9 1.1 2.6 c 0.7 0.7 1.7 1.1 2.8 1.1 z"/>
                            </svg>`,
                    cssClass: "warning"
                },
                "Viktig": {
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54"  class="alert__main__icon ic-alert">
                                <circle fill="#D0021B" cx="27" cy="27" r="27" />
                                <path fill="#FFF" d="M28.631 32.624c.512 0 .768-.242.768-.725l.555-18.174c0-.483-.228-.725-.683-.725h-4.565c-.455 0-.682.242-.682.725l.512 18.174c0 .483.242.725.725.725h3.37zM26.882 42.82c1.11 0 2.04-.363 2.794-1.088.754-.725 1.13-1.6 1.13-2.624 0-.995-.397-1.856-1.194-2.58-.796-.726-1.706-1.089-2.73-1.089s-1.927.363-2.709 1.088c-.782.725-1.173 1.586-1.173 2.581 0 1.024.37 1.899 1.11 2.624.739.725 1.663 1.088 2.772 1.088z"/>
                            </svg>`,
                    cssClass: "alert"
                }
            }

            if (extendItem.metaParsed) {

                let itemParsed = extendItem.metaParsed;

                if (itemParsed.beredskapAlvorlighetsgrad) {
                    type = itemParsed.beredskapAlvorlighetsgrad;
                }
                if (itemParsed.beredskapPlassering) {

                    let itemPlacement = itemParsed.beredskapPlassering;

                    if (itemPlacement.beredskapVisPaaSide) {
                        placement = itemPlacement.beredskapVisPaaSide;
                    }
                    if (placement === "Underside") {
                        let selectedItems = itemPlacement.beredskapSelectedItems;
                        if (selectedItems) {
                            if (selectedItems.length > 0) {
                                selectedItems.forEach(placethis => {
                                    warnPages.push(placethis.contentId);
                                })
                            }
                        }
                    }
                }
            }

            let itemHtml = warningHtml({
                title: title,
                content: content,
                cssClass: types[type].cssClass,
                icon: types[type].icon,
                guid: guid,
                contentId: extendItem.contentId
            }, placement.replace(" ", "").toLowerCase());

            if (placement == "Underside") {
                if (warnPages.indexOf(articleId) > -1) {
                    messages.push(itemHtml);
                }
            }
            else if (placement == "Forside" && articleId === "") {
                messages.push(itemHtml);
            }
            else if (placement === "Hele portalen") {
                messages.push(itemHtml);
            }
        });
    }

    messages = messages.join("");
    return messages;
}

export const getApiWarnings = () => {

    let clientid = getConfig().clientId;

    $.when(
        $.getJSON(window.apiUrl + "/api/PublicContentApi/getcontentlist/" + clientid + "/mal_beredskap/100/0/Modified"),
    ).done(function(warnings) {


        let messages = setWarning(warnings);

        // console.log("all",messages);

        $("#warnings_container").html(messages);

    });

    $("body").on("click", ".alert__main__close", function() {
        let id = $(this).data("dismiss");
        let contentId = $(this).data("contentid");
        $(`[data-warningid=${id}]`).addClass("d-none");
        sessionStorage.setItem("hide-warning-" + contentId, Date.now());

        setHeaderWarning();
    });
}

export const setHeaderWarning = () => {
    return;
}
